<template>
  <div class="page_container goodsManagePage">
    <div class="breadcrumb flex-rowl">
      <!-- <router-link to="/manage">SKU管理</router-link>
      <span class="arrow"><i class="iconfont icon-arrow"></i></span>
      <span>商品管理</span> -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >促销优惠&市场活动</el-breadcrumb-item
        >
        <el-breadcrumb-item>市场活动管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 主要内容 start -->
    <div class="main_container">
      <div class="operation_wrap flex-between">
        <div class="select_add flex-rowl">
          <!-- <router-link to="/ShopIndex/addShop"></router-link> -->
          <p class="flex-rowl" @click="handleGo('', 'addShop')">
            <i class="iconfont icon-xinzeng"></i> 新增
          </p>
        </div>
        <div class="filter flex-rowr">
          <div class="search_wrap flex-between">
            <el-input
              v-model="params.keyword"
              placeholder="关键词查找"
              @keyup.enter.native="handleSearch()"
            ></el-input>
            <div class="search_btn flex-rowc" @click="handleSearch">
              <i class="iconfont icon-chazhaotubiao"></i>
            </div>
          </div>
          <div class="sort_wrap flex-rowc" @click="handleRest">
            <span>重置显示市场活动列表</span>
            <i class="iconfont icon-shuaxin"></i>
          </div>
        </div>
      </div>
      <div
        class="list_wrap"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      >
        <template v-if="dataList.length > 0">
          <div class="item_wrap" v-for="item in dataList" :key="item.id">
            <div class="item_main_wrap flex-rowl">
              <div class="content_wrap flex-between">
                <div class="pic_box">
                  <el-image :src="item.actcover" fit="contain">
                    <div slot="error" class="image-slot flex-rowc">
                      <i class="iconfont icon-zanwutupian1"></i>
                    </div>
                  </el-image>
                </div>
                <div class="intro_box flex-rowl">
                  <div class="block">
                    <p>
                      活动名称：<span>{{ item.actname }}</span>
                    </p>
                    <p>
                      活动城市：<span>{{ item.city }}</span>
                    </p>
                    <p>
                      活动地标：<span>{{ item.position }}</span>
                    </p>
                    <p>
                      活动关联门店：<span>{{ item.shopcodestr }}</span>
                    </p>
                    <p>
                      企业关联业务端场景：<span>{{ item.linkappidstr }}</span>
                    </p>
                  </div>

                  <div class="block">
                    <p>
                      开始预约日期：<span>{{
                        item.joinsdate | formatDate
                      }}</span>
                    </p>
                    <p>
                      结束预约日期：<span>{{
                        item.joinedate | formatDate
                      }}</span>
                    </p>
                    <p>
                      活动开始日期&时间：<span>{{
                        item.sdate | formatDate
                      }}</span>
                    </p>
                    <p>
                      活动结束日期&时间：<span>{{
                        item.edate | formatDate
                      }}</span>
                    </p>
                    <p>
                      活动花费类型：<span>{{ item.costtype }}</span>
                    </p>
                    <p>
                      是否仅限会员参加：<span>{{ item.isactpermis }}</span>
                    </p>
                  </div>

                  <div class="block">
                    <p>
                      创建日期：<span>{{ item.createdate | formatDate }}</span>
                    </p>
                    <p>
                      创建人姓名：<span>{{ item.truename }}</span>
                    </p>
                    <p>
                      创建人手机号：<span>{{ item.mobile }}</span>
                    </p>
                    <p>
                      创建人所属企业：<span>{{ item.appidstr }}</span>
                    </p>
                  </div>
                </div>
                <div class="operation_box flex-colt">
                  <a href="javascript:;" @click="handleGo(item.id, 'addShop')"
                    >基础信息设置</a
                  >
                  <a
                    href="javascript:;"
                    @click="handleGo(item.id, 'activityRecord')"
                    >活动预约记录</a
                  >
                  <a
                    href="javascript:;"
                    @click="handleGo(item.id, 'shopBanner')"
                    >活动banner</a
                  >
                  <a
                    href="javascript:;"
                    @click="handleGo(item.id, 'activityList')"
                    >活动详情</a
                  >
                </div>
              </div>
            </div>
            <div class="shop_more"></div>
          </div>
        </template>
        <el-empty
          description="暂无数据"
          v-if="!loading && dataList.length == 0"
        ></el-empty>
      </div>
    </div>
    <!-- 主要内容 end -->

    <!-- 分页 start -->
    <div class="pagination_wrap flex-rowc">
      <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next, jumper"
        :page-size="10"
        :total="listTotal"
      >
      </el-pagination>
    </div>
    <!-- 分页 end -->

    <!-- 弹窗内容展示 start -->
    <div class="custom_dialog" v-show="isShow">
      <div class="custom_wrap">
        <div class="custom_diaog_body">
          <div class="ercode">
            <el-image style="height: 430px" :src="shopPopupImg"></el-image>
          </div>
          <div class="download">
            <a :href="shopPopupImg" target="_blank" download="image.png"
              >下载图片</a
            >
          </div>
        </div>
        <div class="close" @click="isShow = false">
          <i class="iconfont icon-jujueweituo"></i>
        </div>
      </div>
    </div>
    <!-- 弹窗内容展示 end -->
  </div>
</template>

<script>
import { getMenuAuthTwo, encryptstringadd } from "../../api/api";
import { getActivityList } from "../../api/shop";
import { mapState } from "vuex";
export default {
  name: "shopIndex",
  data() {
    return {
      baseUrl: process.env.VUE_APP_IMG_BASE_API,
      menuItem: "", // 权限菜单
      roleId: "", // 用户角色ID
      operationAuth: "", // 操作权限
      buttonAuth: "", // 按钮权限

      isShow: false,
      loading: false,
      listTotal: 0,
      dataList: [],
      params: {
        pageindex: 1,
        pagesize: 10,
        keyword: "",
        qyguid: "",
        openid: "",
      },

      dataItem: "", // 单个商品
      shopPopupImg: "",
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  created() {
    let { menuItem, USERINFO } = this.$store.state;
    if (USERINFO.qy) {
      this.params.qyguid = USERINFO.qy.qyguid;
    } else {
      this.params.qyguid = 0;
    }
    this.roleId = USERINFO.roleid;
    this.menuItem = menuItem;
    this.getMenuAuthTwo();
    this.initData();
  },
  methods: {
    // 获取菜单栏权限
    getMenuAuthTwo() {
      let menuItem = this.$store.state.menuItem;
      getMenuAuthTwo(menuItem.parentid).then((res) => {
        res
          .filter((item) => {
            return item.id == menuItem.id;
          })
          .map((item) => {
            // 操作权限
            if (item.dorange) {
              this.operationList = item.dorange.split(",");
            }
          });
      });
    },

    handleCurrentChange(e) {
      this.params.pageindex = e;
      // this.dataList = [];
      this.initData();
    },
    handleSearch() {
      this.params.pageindex = 1;
      this.initData();
    },
    // 重置数据
    handleRest() {
      this.params.pageindex = 1;
      this.params.keyword = "";
      this.initData();
    },
    initData() {
      let { params } = this;
      this.loading = true;
      getActivityList(params).then((res) => {
        this.listTotal = res.total;
        // this.dataList = res.list.concat(...this.dataList);
        this.dataList = res.list;
        this.loading = false;
        // this.dataList = this.dataList.concat(...res.list);
      });
    },

    handleGo(id, name) {
      if (id == "") {
        this.encryptstringadd(name, "");
      } else {
        this.encryptstringadd(name, { id });
      }
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          // this.$router.push({
          //   name,
          //   params,
          // })
          window.open(this.$router.resolve({ name, params }).href, "_blank");
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManagePage {
  .main_container {
    .screen_wrap {
      font-size: 14px;
      margin-right: 30px;
      .txt {
        cursor: pointer;
        &.active {
          font-size: 16px;
          color: red;
        }
        &:nth-child(2) {
          margin: 0 20px;
        }
      }
    }
    .shop_list {
      .shop_more {
        height: 50px;
        border-top: 1px solid #fff;
      }
    }
    .ercode {
      margin-top: 10px;
      cursor: pointer;
    }
  }
  .custom_dialog {
    .custom_wrap {
      width: 500px;
      height: 500px;
      .custom_diaog_body {
        height: 100%;
        box-sizing: border-box;
        // padding-top: 50px;
        .ercode {
          text-align: center;
          // margin-bottom: 32px;
        }
        .txt {
          p {
            text-align: center;
            font-size: 20px;
            color: #000000;
            margin-bottom: 10px;
            &:last-child {
              margin-bottom: 30px;
            }
          }
        }
        .download {
          text-align: center;
          a {
            font-size: 18px;
            color: #0006ff;
            border-bottom: 1px solid #0006ff;
            padding-bottom: 5px;
          }
        }
      }
      .close {
        position: absolute;
        left: 50%;
        color: #fff;
        bottom: -50px;
        transform: translateX(-50%);
        cursor: pointer;
        .iconfont {
          font-size: 30px;
        }
      }
    }
  }
}
</style>